'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _semanticUiReact = require('semantic-ui-react');

var _demographicsAgeGraph = require('../../components/demographics-age-graph');

var _demographicsAgeGraph2 = _interopRequireDefault(_demographicsAgeGraph);

var _demographicsGenderGraph = require('../../components/demographics-gender-graph');

var _demographicsGenderGraph2 = _interopRequireDefault(_demographicsGenderGraph);

var _followersBarChart = require('../../components/followers-bar-chart');

var _followersBarChart2 = _interopRequireDefault(_followersBarChart);

var _locationTabs = require('./location-tabs');

var _locationTabs2 = _interopRequireDefault(_locationTabs);

var _formatting = require('../../utils/formatting');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noBottomPadding = {
  paddingBottom: 0
};

var dividerStyle = {
  marginTop: 5,
  marginBottom: 5
};

var textCenter = {
  textAlign: 'center'
};

var MODAL_LINK_STYLE = (0, _extends3.default)({
  cursor: 'pointer'
}, textCenter);

var DYZIO_APP_ID = '116451675157336';

var FacebookProfileDataLarge = function FacebookProfileDataLarge(props) {
  var influencer = props.influencer,
      handle = props.handle,
      facebookVerified = props.facebookVerified,
      countHistory = props.countHistory,
      pageMetrics = props.pageMetrics,
      displayAuthorisedData = props.displayAuthorisedData;


  if (!handle) return null;

  var cleanHandle = _lodash2.default.replace(handle, 'https://www.facebook.com/', '');
  var facebookHistory = _lodash2.default.filter(countHistory, function (item) {
    return _lodash2.default.has(item, 'facebookCount');
  });
  var lastFBHistoryItem = _lodash2.default.last(facebookHistory);

  var _ref = pageMetrics || { data: {} },
      _ref$data = _ref.data,
      engagements = _ref$data.engagements,
      views = _ref$data.views,
      impressions = _ref$data.impressions,
      consumptions = _ref$data.consumptions,
      videos = _ref$data.videos;

  var usingOldFormat = !!_lodash2.default.last(_lodash2.default.get(engagements, 'values')); /* TODO(Kai): Depricate then remove this line */

  var graphProps = {
    label: 'followers',
    labels: _lodash2.default.map(facebookHistory, function (item) {
      return (0, _moment2.default)(item.createdDate).format('MMM D');
    }),
    values: _lodash2.default.map(facebookHistory, 'facebookCount'),
    rgbColorCode: '#3B5998'
  };

  var canRenderModals = false;

  var lastFacebookCount = _lodash2.default.get(lastFBHistoryItem, 'facebookCount', null);
  return _react2.default.createElement(
    _semanticUiReact.Segment,
    { color: 'blue' },
    _react2.default.createElement(
      _semanticUiReact.Grid,
      null,
      _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 16 },
          _react2.default.createElement(
            'h3',
            null,
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'facebook', color: 'blue' }),
            'Facebook'
          ),
          _react2.default.createElement(_semanticUiReact.Divider, null)
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 3 },
          _react2.default.createElement(_semanticUiReact.Image, {
            src: 'https://graph.facebook.com/v2.11/' + cleanHandle + '/picture?redirect=1&app_id=' + DYZIO_APP_ID,
            className: 'circular',
            centered: true,
            size: 'small'
          }),
          _react2.default.createElement(
            _semanticUiReact.Table,
            { basic: 'very', fluid: true, textAlign: 'center' },
            _react2.default.createElement(
              _semanticUiReact.Table.Body,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  cleanHandle,
                  facebookVerified && _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'blue' })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  (0, _formatting.commaFormatted)(lastFacebookCount),
                  ' followers'
                )
              ),
              !facebookVerified && _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  _react2.default.createElement(_semanticUiReact.Popup, {
                    trigger: _react2.default.createElement(_semanticUiReact.Label, { basic: true, color: 'grey', content: 'not verified' }),
                    content: cleanHandle + ' is not verified by Facebook (blue tick)'
                  })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 8 },
          _react2.default.createElement(_followersBarChart2.default, (0, _extends3.default)({}, graphProps, { percentageRange: 0.5 }))
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 5 },
          _react2.default.createElement(
            'h4',
            { style: textCenter },
            'Last 28 days page insights'
          ),
          _react2.default.createElement(
            _semanticUiReact.Table,
            { basic: 'very', fluid: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Body,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  'total page followers'
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  (0, _formatting.commaFormatted)(lastFacebookCount)
                )
              ),
              !usingOldFormat && displayAuthorisedData && engagements && _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  _react2.default.createElement(_semanticUiReact.Popup, {
                    trigger: _react2.default.createElement(
                      'span',
                      null,
                      'posts engagements',
                      ' ',
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', color: 'blue' })
                    ),
                    content: 'The number of times people have engaged with page posts through like, comments and shares and more.'
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  (0, _formatting.commaFormatted)(engagements.value)
                )
              ),
              !usingOldFormat && displayAuthorisedData && views && _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  _react2.default.createElement(_semanticUiReact.Popup, {
                    trigger: _react2.default.createElement(
                      'span',
                      null,
                      'views ',
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', color: 'blue' })
                    ),
                    content: 'Total views count per Page'
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  (0, _formatting.commaFormatted)(views.value)
                )
              ),
              !usingOldFormat && displayAuthorisedData && impressions && _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  _react2.default.createElement(_semanticUiReact.Popup, {
                    trigger: _react2.default.createElement(
                      'span',
                      null,
                      'impressions',
                      ' ',
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', color: 'blue' })
                    ),
                    content: 'The number of times your Page\'s posts entered a person\'s screen. Posts include statuses, photos, links, videos and more. (Total Count)'
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  (0, _formatting.commaFormatted)(impressions.value)
                )
              ),
              !usingOldFormat && displayAuthorisedData && consumptions && _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  _react2.default.createElement(_semanticUiReact.Popup, {
                    trigger: _react2.default.createElement(
                      'span',
                      null,
                      'consumptions',
                      ' ',
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', color: 'blue' })
                    ),
                    content: 'The number of clicks on any of page content. Stories generated without clicks on page content (e.g., liking the page in Timeline) are not included. (Total Count)'
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  (0, _formatting.commaFormatted)(consumptions.value)
                )
              ),
              !usingOldFormat && displayAuthorisedData && videos && _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  _react2.default.createElement(_semanticUiReact.Popup, {
                    trigger: _react2.default.createElement(
                      'span',
                      null,
                      'videos engagements',
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', color: 'blue' })
                    ),
                    content: 'Total number of times videos have been viewed for more than 3 seconds. (Total Count)'
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  (0, _formatting.commaFormatted)(videos.value)
                )
              )
            )
          ),
          !usingOldFormat && canRenderModals && displayAuthorisedData && _react2.default.createElement(
            'div',
            { style: textCenter },
            _react2.default.createElement(
              'a',
              {
                style: MODAL_LINK_STYLE,
                onClick: undefined.onFullPageMetrics
              },
              'View full page metric data'
            )
          )
        )
      ),
      displayAuthorisedData && props.audienceDemographics && props.audienceLocations && _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        { textAlign: 'center', style: noBottomPadding, divided: true },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 16 },
          _react2.default.createElement(_semanticUiReact.Divider, { fitted: true, style: dividerStyle }),
          _react2.default.createElement(
            'h2',
            null,
            'Audience Demographics and Regions',
            _react2.default.createElement(_semanticUiReact.Popup, {
              trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock', color: 'orange' }),
              content: 'Private data collected from Facebook API'
            })
          ),
          _react2.default.createElement(_semanticUiReact.Divider, { fitted: true, style: dividerStyle })
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 4, verticalAlign: 'middle' },
          _react2.default.createElement(
            'h5',
            null,
            'Viewing by Gender'
          ),
          _react2.default.createElement(_demographicsGenderGraph2.default, props)
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 7, verticalAlign: 'middle' },
          _react2.default.createElement(
            'h5',
            null,
            'Channel demographic by gender / age'
          ),
          _react2.default.createElement(_demographicsAgeGraph2.default, props)
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 5 },
          _react2.default.createElement(_locationTabs2.default, props)
        )
      )
    )
  );
};

FacebookProfileDataLarge.defaultProps = {
  enforceWhiteListCheck: false,
  facebookVerified: false,
  audienceLocations: null,
  audienceDemographics: null,
  pageMetrics: null,
  facebookCountryDemographicsModalOpen: false,
  facebookCityDemographicsModalOpen: false,
  pageMetricModalOpen: false
};

exports.default = FacebookProfileDataLarge;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/facebook-profile-data-large/index.js
 ** module id = 2564
 ** module chunks = 0
 **/